export const gtableConfig = {
    'success' : [
        'active',
    ],
    'danger' : [
        'dormant',
        'expired',
    ],
    'dark' : [
        'general',
        'cancelled',
        'active_member',
    ],
    'primary' : [
        'objection_listing',
        'newsletter_subscriber',
        'created',
    ],
}
